import React, { Suspense, useCallback, useEffect, useState } from "react";
import styles from "./items.module.scss";
import {
  Alert,
  Box,
  Button,
  ClickAwayListener,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Snackbar,
  styled,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import Icon from "@mdi/react";
import {
  mdiAlertCircleOutline,
  mdiCheck,
  mdiClose,
  mdiDotsVertical,
  mdiTrayArrowDown,
} from "@mdi/js";
import {
  ActiveSwitch,
  CustomSwitch,
  CustomPagination,
  Datatable,
  InactiveDialog,
  Loader,
  SearchInput,
} from "../../../../components";
import { GridColDef, GridRowId, GridRowSelectionModel, useGridApiRef } from "@mui/x-data-grid";
import { itemService } from "../../../../api/services";
import { IAddItem } from "../../../../interfaces/IAddItem";
import { MasterSection } from "../../../../enums/MasterSection";
import { AddItemDialog, ImportSheetDialog } from "../../../../containers";
import { DialogMessage } from "../../../../utils/Enum/DialogMessage";
import { useClient } from "../../../../utils/ClientContext";
import { MasterExport } from "../../../../utils/Enum/MasterExport";
import { IMasterExportProps } from "../../../../interfaces";
import ThreeStateSwitch from "../../../../components/CustomSwitch/ThreeStateSwitch";

const ActionMenu: React.FC<{
  id: number;
  rowData: any;
  onEdit: (data: any) => void;
}> = ({ id, rowData, onEdit }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    onEdit(rowData);
    handleClose();
  };

  return (
    <>
      <IconButton
        aria-controls="action-menu"
        aria-haspopup="true"
        onClick={handleClick}
        aria-label="edit"
      >
        <Icon path={mdiDotsVertical} aria-label="edit" size={1} />
      </IconButton>
      <Menu
        id={`action-menu-${id}`}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className={styles.actionMenulist}
      >
        <MenuItem onClick={handleEdit} className={styles.actionMenuitem}>
          Edit
        </MenuItem>
      </Menu>
    </>
  );
};
const HeaderActionMenu: React.FC<{
  selectedRows: any;
  disabled?: boolean; 
  handleItemFlagChange: any;
  handleStatusChange: any;
}> = ({  disabled = false , selectedRows,handleItemFlagChange,handleStatusChange}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [menuOpenCounter, setMenuOpenCounter] = useState(0);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!disabled) {
      setAnchorEl(event.currentTarget);
      setMenuOpenCounter((prev) => prev + 1);
    }
  };

  const handleClose = () => {
    setAnchorEl(null); 
  };
    const handleSerializationToggle = (isActive: boolean| null) => {
      const selectedIds = Array.isArray(selectedRows) ? selectedRows.map((row) => row.id)
      : []; 
       handleItemFlagChange(selectedIds, isActive, true, "serialization");
      handleClose();
    };
    
    const handleLotToggle = (isActive: boolean | null) => {
      const selectedIds = Array.isArray(selectedRows) ? selectedRows.map((row) => row.id) : []; 
      handleItemFlagChange(selectedIds, isActive, true, "lot");
      handleClose();
    };
    const handleStatusToggle = (isActive: boolean | null) => {
      const selectedIds = Array.isArray(selectedRows) ? selectedRows.map((row) => row.id) : []; 
      handleStatusChange(selectedIds, isActive);
      handleClose();
    };
    const getUniformValue = (key: string): boolean | null => {
      if (!Array.isArray(selectedRows) || selectedRows.length === 0) return null;
      
      const firstValue = selectedRows[0][key];
      const allSame = selectedRows.every((row) => row[key] === firstValue);
      
      return allSame ? firstValue : null;
    };
    
    const lottedValue = getUniformValue("isLotted");
    const serializedValue = getUniformValue("isSerialized"); 
    const statusValue = getUniformValue("isActive");
  const isReadOnly = selectedRows.some((item: { inInventory: boolean }) => item.inInventory);
  return (
<>
        <MenuItem
          className={styles.actionMenuitem}
          disableRipple
          sx={{
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Box display="flex" alignItems="center" gap={1.5}>
            {statusValue === null ? (
              <ThreeStateSwitch
                key={menuOpenCounter}
                state={null}
                onChange={(newState) => {
                  handleStatusToggle(newState);
                }}
                Title=""
                ReadonlyTitle=""
                isConfirmationOnTrue={false}
                isConfirmationOnFalse={true}
                isConfirmationOnNull={false}
                confirmMessageFalse={DialogMessage.Dialog_Message_Inactive_Item}
                confirmTitleNull=""
                confirmMessageNull=""
                IsReadOnly={false}
              />
            ) : (
              <CustomSwitch
                key={menuOpenCounter}
                isActive={statusValue}
                isConfirmationOnActive={false}
                isConfirmationOnInActive={true}
                IsReadOnly={false}
                confirmMessageInactive={
                  DialogMessage.Dialog_Message_Inactive_Item
                }
                onChange={(event: any) => {
                  handleStatusToggle(event.target.checked);
                }}
              />
            )}

            <Typography>
              {" "}
              {statusValue === true
                ? "Make Inactive"
                : statusValue === false
                ? "Make Active"
                : "Make Active/Inactive"}{" "}
              ({selectedRows.length})
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem
          className={styles.actionMenuitem}
          disableRipple
          sx={{
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Box display="flex" alignItems="center" gap={1.5}>
            {serializedValue === null ? (
              <ThreeStateSwitch
                key={menuOpenCounter}
                state={null}
                onChange={(newState) => {
                  handleSerializationToggle(newState);
                }}
                Title=""
                ReadonlyTitle={
                  DialogMessage.Dialog_Toolotip_Readonly_Serialization_Lot_Multiselect
                }
                isConfirmationOnTrue={true}
                isConfirmationOnFalse={true}
                isConfirmationOnNull={false}
                confirmTitleTrue={
                  DialogMessage.Dialog_Message_Serialization_Active_Title
                }
                confirmMessageTrue={
                  DialogMessage.Dialog_Message_Serialization_Active_Message
                }
                confirmTitleFalse={
                  DialogMessage.Dialog_Message_Serialization_InActive_Title
                }
                confirmMessageFalse={
                  DialogMessage.Dialog_Message_Serialization_InActive_Message
                }
                confirmTitleNull=""
                confirmMessageNull=""
                IsReadOnly={isReadOnly}
              />
            ) : (
              <CustomSwitch
                key={menuOpenCounter}
                isActive={serializedValue}
                onConfirmInactive={() => handleSerializationToggle(false)}
                isConfirmationOnActive={true}
                confirmTitleActive={
                  DialogMessage.Dialog_Message_Serialization_Active_Title
                }
                confirmMessageActive={
                  DialogMessage.Dialog_Message_Serialization_Active_Message
                }
                isConfirmationOnInActive={true}
                IsReadOnly={isReadOnly}
                ReadonlyTitle={
                  DialogMessage.Dialog_Toolotip_Readonly_Serialization_Lot_Multiselect
                }
                confirmTitleInactive={
                  DialogMessage.Dialog_Message_Serialization_InActive_Title
                }
                confirmMessageInactive={
                  DialogMessage.Dialog_Message_Serialization_InActive_Message
                }
                onChange={(event: any) => {
                  handleSerializationToggle(event.target.checked);
                }}
              />
            )}

            <Typography>Serialization ({selectedRows.length})</Typography>
          </Box>
        </MenuItem>
        <MenuItem
          className={styles.actionMenuitem}
          disableRipple
          sx={{
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Box display="flex" alignItems="center" gap={1.5}>
            {lottedValue === null ? (
              <ThreeStateSwitch
                key={menuOpenCounter}
                state={null}
                onChange={(newState) => {
                  handleLotToggle(newState);
                }}
                Title=""
                ReadonlyTitle={
                  DialogMessage.Dialog_Toolotip_Readonly_Serialization_Lot_Multiselect
                }
                isConfirmationOnTrue={true}
                isConfirmationOnFalse={true}
                isConfirmationOnNull={false}
                confirmTitleTrue={DialogMessage.Dialog_Message_Lot_Active_Title}
                confirmMessageTrue={
                  DialogMessage.Dialog_Message_Lot_Active_Message
                }
                confirmTitleFalse={
                  DialogMessage.Dialog_Message_Lot_InActive_Title
                }
                confirmMessageFalse={
                  DialogMessage.Dialog_Message_Lot_InActive_Message
                }
                confirmTitleNull=""
                confirmMessageNull=""
                IsReadOnly={isReadOnly}
              />
            ) : (
              <CustomSwitch
                key={menuOpenCounter}
                isActive={lottedValue}
                onConfirmInactive={() => handleLotToggle(false)}
                isConfirmationOnActive={true}
                confirmTitleActive={
                  DialogMessage.Dialog_Message_Lot_Active_Title
                }
                confirmMessageActive={
                  DialogMessage.Dialog_Message_Lot_Active_Message
                }
                isConfirmationOnInActive={true}
                IsReadOnly={isReadOnly}
                ReadonlyTitle={
                  DialogMessage.Dialog_Toolotip_Readonly_Serialization_Lot_Multiselect
                }
                confirmTitleInactive={
                  DialogMessage.Dialog_Message_Lot_InActive_Title
                }
                confirmMessageInactive={
                  DialogMessage.Dialog_Message_Lot_InActive_Message
                }
                onChange={(event: any) => {
                  handleLotToggle(event.target.checked);
                }}
              />
            )}

            <Typography>Lot-Based Tracking ({selectedRows.length})</Typography>
          </Box>
        </MenuItem>
    </>
  );
}; 


const Items: React.FC<IMasterExportProps> = ({ onExportMastersData }) => {
  const dialogMessage = DialogMessage.Dialog_Message_Inactive_Item;
  const [formData, setFormData] = useState<IAddItem | null>(null);
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = React.useState(0);
  const [error, setError] = useState<string | null>(null);
  const [emptyState, setEmptyState] = React.useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [importSheetDialogOpen, setImportSheetDialogOpen] =
    useState<boolean>(false);
    const [pageSize, setPageSize] = useState<number>(100);
  const apiRef = useGridApiRef();
  const [severity, setSeverity] = useState<"success" | "error">("success");
  const [showLoader, setShowLoader] = useState(false);
const [headerMenuAnchor, setHeaderMenuAnchor] = useState<HTMLElement | null>(null);
// Handles the page change event
 const handlePageChange = (newPage: number) => {
   setPage(newPage);
};
const handleFirstPage = () => {
  setPage(0);
};

const handleLastPage = () => {
  setPage(pageCount - 1);
};

const handleNextPage = () => {
  if (page < pageCount - 1) {
    setPage((prev) => prev + 1);
  }
};

const handlePreviousPage = () => {
  if (page > 0) {
    setPage((prev) => prev - 1);
  }
};
  // Dynamically assign custom icons based on severity
  const getIcon = () => {
    if (severity === "success") {
      return <Icon path={mdiCheck} size={1} />; // Custom success icon
    }
    return <Icon path={mdiAlertCircleOutline} size={1} />; // Custom error icon
  };
  //Close Snackbar
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const columns: GridColDef[] = [
    {
      field: "code",
      headerName: "Code",
      width: 150,
      minWidth: 150,
      flex: 1.5,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
       <Tooltip title={params.value} placement="bottom" arrow>
      <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%" }}>
        {params.value?.length > 20 ? params.value.slice(0, 20) + "..." : params.value}
      </span>
    </Tooltip>
      ),
    },
    {
      field: "description",
      headerName: "Description",
      width: 200,
      minWidth: 150,
      flex: 2,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span style={{ whiteSpace: "pre-wrap" }}>{params.value}</span>
      ),
    },
    {
      field: "uomName",
      headerName: "UOM",
      width: 100,
      minWidth: 100,
      flex: 0.8,
      sortable: false,
      disableColumnMenu: true,renderCell: (params) => (
        <span style={{ whiteSpace: "pre-wrap" }}>{params.value}</span>
      ),
    },
    {
      field: "cost",
      headerName: "Cost",
      width: 100,
      minWidth: 100,
      flex: 0.5,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "isSerialized",
      headerName: "Serialization",
     
      sortable: false,
      flex: 1,
      width: 108,
      minWidth: 100,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" width="100%" height="100%">
          <CustomSwitch
            isActive={params.row.isSerialized}
            onConfirmInactive={() => handleMakeSerializeInactive(params.row.id)}
            isConfirmationOnActive={true}
            confirmTitleActive={DialogMessage.Dialog_Message_Serialization_Active_Title}
            confirmMessageActive={DialogMessage.Dialog_Message_Serialization_Active_Message}
            isConfirmationOnInActive={true}
            IsReadOnly={params.row.inInventory}
            ReadonlyTitle={DialogMessage.Dialog_Toolotip_Readonly_Serialization_Lot}
            confirmTitleInactive={DialogMessage.Dialog_Message_Serialization_InActive_Title}
            confirmMessageInactive={DialogMessage.Dialog_Message_Serialization_InActive_Message}
            onChange={(event:any) => {
              const newActiveStatus = event.target.checked;
              handleItemFlagChange([params.row.id], newActiveStatus, false, 'serialization');
            }}
          />
        </Box>
      ),
    },
    {
      field: "isLotted",
      headerName: "Lot Tracking",
      sortable: false,
      flex: 1,
      width: 108,
      minWidth: 100,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" width="100%" height="100%">
          <CustomSwitch
            isActive={params.row.isLotted}
            onConfirmInactive={() => handleMakeLotInactive(params.row.id)}
            isConfirmationOnActive={true}
            confirmTitleActive={DialogMessage.Dialog_Message_Lot_Active_Title}
            confirmMessageActive={DialogMessage.Dialog_Message_Lot_Active_Message}
            isConfirmationOnInActive={true}
            IsReadOnly={params.row.inInventory}
            ReadonlyTitle={DialogMessage.Dialog_Toolotip_Readonly_Serialization_Lot}
            confirmTitleInactive={DialogMessage.Dialog_Message_Lot_InActive_Title}
            confirmMessageInactive={DialogMessage.Dialog_Message_Lot_InActive_Message}
            onChange={(event:any) => {
              const newActiveStatus = event.target.checked;
              handleItemFlagChange([params.row.id], newActiveStatus, false, 'lot');
            }}
          />
        </Box>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      sortable: false,
      flex: 1,
      width: 120,
      minWidth: 120,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" width="100%" height="100%">
          <ActiveSwitch
            isActive={params.row.isActive}
            onConfirmInactive={() => handleMakeInactive(params.row.id)}
            message={dialogMessage}
            onChange={(event) => {
              const newActiveStatus = event.target.checked;
              handleStatusChange(params.row.id, newActiveStatus, false);
            }}
          />
        </Box>
      ),
    },
    {
      field: "actions",
      headerName: "",
      sortable: false,
      width: 80,
      minWidth: 80,
      align: "right",
    
  headerAlign: "right", 
    renderHeader: () => (
  <IconButton disabled={selectedRows.length === 0}
    onClick={(e) => setHeaderMenuAnchor(headerMenuAnchor ? null : e.currentTarget)}
    size="small"
  >
    <Icon path={mdiDotsVertical} size={1} />
  </IconButton>
),
      renderCell: (params) => (
        <ActionMenu
          id={params.row.id}
          rowData={params.row}
          onEdit={handleEdit}
        />
      ),
    },
  ];
  const handleStatusChange = async (
    id: number,
    isActive: boolean,
    isConfirm: boolean
  ) => {
    if (isActive) {
      setShowLoader(true);
      try {
        const rowId: string[] = [id.toString()];
        const requestBody = {
          ids: rowId,
          isActive: isActive,
        };
        const response = await itemService.updateItemStatus(requestBody);
        if (response.isSuccess) {
          handleRefresh();
        }
        setSnackbarMessage("Item status updated successfully.");
        setSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          handleCloseSnackbar();
        }, 5000);
      } catch (error) {
        setSnackbarMessage("Failed to update status.");
        setSeverity("error");
        setOpenSnackbar(true);
      }finally {
        setShowLoader(false);
      }
    } else {
      if (isConfirm) {
        try {setShowLoader(true);
          const rowId: string[] = [id.toString()];
          const requestBody = {
            ids: rowId,
            isActive: isActive,
          };

          const response = await itemService.updateItemStatus(requestBody);
          if (response.isSuccess) {
            handleRefresh();
            setSnackbarMessage("Item status updated successfully.");
            setSeverity("success");
            setOpenSnackbar(true);
            setTimeout(() => {
              handleCloseSnackbar();
            }, 5000);
          }
        } catch (error) {
          console.error("Failed to update status:", error);
        }finally {
          setShowLoader(false);
        }
      }
    }
  };
  const handleItemFlagChange = async (
    ids: number[],
    isActive: boolean,
    isConfirm: boolean,
    flagType: "serialization" | "lot"
  ) => {
    if (isActive || isConfirm) {
      setShowLoader(true);
      try {
        const requestBody: any = {
          ids: Array.isArray(ids) ? ids.filter(id => id !== undefined).map(id => id.toString()) : [],
          isActive: isActive
        };
  
        if (flagType === "serialization") {
          requestBody.IsChangeItemSerialization = true;
        } else if (flagType === "lot") {
          requestBody.IsChangeItemLot = true;
        }
  
        const response = await itemService.updateItemFlags(requestBody);
  
        if (response.isSuccess) {
          setTimeout(() => {
            handleRefresh();
          }, 200);
  
          setSnackbarMessage("Items updated successfully.");
          setSeverity("success");
          setOpenSnackbar(true);
  
          setTimeout(() => {
            handleCloseSnackbar();
          }, 5000);
        }
      } catch (error) {
        console.error(`Failed to update ${flagType}:`, error);
        setSnackbarMessage("Failed to update the items.");
        setSeverity("error");
        setOpenSnackbar(true);
      } finally {
        setShowLoader(false);
      }
    }
  };
  
  
  const handleMakeInactive = (id: number) => {
    handleStatusChange(id, false, true);
  };
  const handleMakeSerializeInactive = (id: number) => {
    handleItemFlagChange([id], false, true, 'serialization');
  };
  const handleMakeLotInactive = (id: number) => {
    handleItemFlagChange([id], false, true, 'lot');
  };
  const handleEdit = (data: any) => {
    setFormData(data);
    setAddItemDialogOpen(true);
  };
  const [rows, setRows] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  
      const [searchKey, setSearchKey] = useState<string>("");
  const [refreshTrigger, setRefreshTrigger] = useState<boolean>(false);
  const [pendingAction, setPendingAction] = useState<
    (() => Promise<void>) | undefined
  >(undefined);
  const [inactiveDialogOpen, setInactiveDialogOpen] = useState(false);
  const handleInactiveDialogClose = () => {
    setInactiveDialogOpen(false);
    getItemsList(page);
  };
  const { client } = useClient();
  const clientId = client.id;
  useEffect(() => {
      setRows([]);
      getItemsList(page);
      handleDeselectAll();
  }, [page,refreshTrigger]);
  useEffect(() => {
      const debounce = setTimeout(() => {
        if (searchKey.length >= 3 || searchKey.length === 0) {
          setRows([]);
          setPage(0);
          setPageCount(0);
          getItemsList(page);
        }
      }, 300);
      return () => clearTimeout(debounce); 
    }, [searchKey, clientId]);
  const userId = Number(localStorage.getItem("userId"));

  const getItemsList = async (page: number) => {
    setShowLoader(true);
    try {
      setHeaderMenuAnchor(null);
      const response = await itemService.getItemsByClient({
        pageSize: pageSize,
        currentPage: page + 1,
        searchTerm: searchKey.length >= 3 ? searchKey : "",
      });
      
      if (response.items.length > 0) {
        setEmptyState(false);
        setRows(response.items)
        setPageCount(Math.ceil(response.totalRecords / pageSize));
       
      } else{
        setEmptyState(
          !searchKey && response.items.length === 0
        );
      }
    } catch (error) {
      setEmptyState(true);
      setSeverity("error");
      setSnackbarMessage("Failed to load items");
      setOpenSnackbar(true);
      console.error(error);
    } finally {
      setShowLoader(false);
    }
  };

  const [AddItemDialogOpen, setAddItemDialogOpen] = React.useState(false);
  const onClickAddItemDialogOpen = () => {
    setAddItemDialogOpen(true);
  };
  const handleRefresh = () => {
    getItemsList(page);
    setRefreshTrigger(!refreshTrigger);
  };

  const handleCloseDialog = () => {
    setFormData(null);
    setAddItemDialogOpen(false);
  };
  const [selectedRowObjects, setSelectedRowObjects] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const handleRowSelectionChange = (newSelection: number[], allRows: any[]) => {
    setSelectedRows(newSelection);
    if (Array.isArray(rows)) {
      const rowMap = new Map(rows.map((row) => [row.id, row]));
      const selectedObjects = newSelection.map((id) => rowMap.get(id)).filter(Boolean);
      setSelectedRowObjects(selectedObjects);
    } else {
      setSelectedRowObjects([]);
      console.warn("Expected 'rows' to be an array, but got:", rows);
    }
  };
  
  const handleDeselectAll = () => {
    // Deselect all rows
    if (apiRef.current) {
      apiRef.current.setRowSelectionModel({
      type: 'include',
      ids: new Set<GridRowId>()
    });
    }
  };


  const handleMarkInactive = async (selectedRows: number[], isActive : boolean) => {
    setShowLoader(true); try {
      const payload = {
        Ids: selectedRows,
        ModifiedBy: userId,
        isActive : isActive
      };
      const response = await itemService.updateItemStatus(payload);
      if (response.isSuccess) {
        handleRefresh();
        handleDeselectAll();
      }
    } catch (err) {
      console.error("Failed to update status", err);
    } finally {
      setInactiveDialogOpen(false);setShowLoader(false);
    }
  };

  return (
    <div className="comman_wrapper">
      {emptyState ? (
        <Grid
          container
          className={styles.dashboard_container_empty}
          size={{ sm: 12, xs: 12 }}
        >
          <Grid size={{ xs: 12 }} className={styles.dashboard_empty_content}>
            <img
              src={process.env.PUBLIC_URL + "/assets/blank_screen_img.svg"}
              alt="Blank Screen Img"
            />
            <h3> Your Items are empty at the moment </h3>
            <h5>
              {" "}
              Please import an excel sheet to start adding your inventory.{" "}
            </h5>
            <Grid className={styles.add_master_btn} size={{ sm: 12, xs: 12 }}>
              <Button
                variant="contained"
                onClick={() => {
                  setImportSheetDialogOpen(true);
                }}
              >
                Import Sheet
              </Button>

              <Button variant="outlined" onClick={onClickAddItemDialogOpen}>
                Add Item
              </Button>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid
          container
          className={styles.datagrid_wrapper}
          size={{ sm: 12, xs: 12 }}
        >
          {selectedRows.length > 0 ? (
            <Grid size={{ xs: 12 }} className={styles.datagrid_top_btns}>
              <Grid
                container
                size={{ xs: 10 }}
                className={styles.searchFilterContainer}
              >
                <Grid size={{ sm: 8 }}>
                  <SearchInput
                    searchKey={searchKey}
                    onChange={setSearchKey}
                    placeholder="Search by Code, Description, UOM, Cost..."
                  />
                </Grid>
              </Grid>
              {selectedRows.length === 0 ? (
                <>
                  {" "}
                  <Button
                    className={styles.headerButton}
                    variant="outlined"
                    onClick={() => setImportSheetDialogOpen(true)}
                  >
                    Import Sheet
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={onClickAddItemDialogOpen}
                    className={styles.headerButton}
                  >
                    Add Item
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => onExportMastersData(MasterExport.Items)}
                  >
                    <Icon path={mdiTrayArrowDown} size={1}></Icon>
                  </Button>{" "}
                </>
              ) : (
                <Box width="330px" />
              )}
            </Grid>
          ) : (
            <Grid size={{ xs: 12 }} className={styles.datagrid_top_btns}>
              <Grid
                container
                size={{ xs: 10 }}
                className={styles.searchFilterContainer}
              >
                <Grid size={{ sm: 8 }}>
                  <SearchInput
                    searchKey={searchKey}
                    onChange={setSearchKey}
                    placeholder="Search by Code, Description, UOM, Cost..."
                  />
                </Grid>
              </Grid>{" "}
              <Button
                className={styles.headerButton}
                variant="outlined"
                onClick={() => setImportSheetDialogOpen(true)}
              >
                Import Sheet
              </Button>
              <Button
                variant="outlined"
                onClick={onClickAddItemDialogOpen}
                className={styles.headerButton}
              >
                Add Item
              </Button>
              <Button
                variant="outlined"
                onClick={() => onExportMastersData(MasterExport.Items)}
              >
                <Icon path={mdiTrayArrowDown} size={1}></Icon>
              </Button>
            </Grid>
          )}
          <Grid size={{ xs: 12 }} className={styles.datagrid_container}>
            <Datatable
              rows={rows}
              columns={columns}
              pagination
              paginationMode="server"
              onPageChange={handlePageChange}
              rowCount={totalCount}
              loading={showLoader}
              disableSelectionOnClick={false}
              error={error}
              checkboxSelection={true}
              apiRef={apiRef}
              onSelectionModelChange={handleRowSelectionChange}
            ></Datatable>
            
            <Popper
              open={!!headerMenuAnchor}
              anchorEl={headerMenuAnchor}
              placement="bottom-end"
              modifiers={[{ name: "offset", options: { offset: [0, 8] } }]}
              popperOptions={{ strategy: "fixed" }} // optional
            >
              <Paper elevation={3} sx={{ zIndex: 2000 }}>
                <ClickAwayListener
                  onClickAway={() => setHeaderMenuAnchor(null)}
                >
                  <MenuList autoFocusItem={!!headerMenuAnchor}>
                    <HeaderActionMenu
                      disabled={selectedRows.length === 0}
                      selectedRows={selectedRowObjects}
                      handleItemFlagChange={handleItemFlagChange}
                      handleStatusChange={handleMarkInactive}
                    />
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Popper>

            <CustomPagination
              page={page}
              pageCount={pageCount || 1}
              handleFirstPage={handleFirstPage}
              handleLastPage={handleLastPage}
              handleNextPage={handleNextPage}
              handlePreviousPage={handlePreviousPage}
            />
          </Grid>
        </Grid>
      )}
      <Suspense fallback={<div>Loading...</div>}>
        {AddItemDialogOpen && (
          <AddItemDialog
            open={AddItemDialogOpen}
            onClose={handleCloseDialog}
            formData={formData}
            onSuccess={handleRefresh}
          />
        )}
        {importSheetDialogOpen && (
          <ImportSheetDialog
            open={importSheetDialogOpen}
            onClose={() => {
              setImportSheetDialogOpen(false);
            }}
            section={MasterSection.Items}
            onSuccess={handleRefresh}
          />
        )}
      </Suspense>
      <InactiveDialog
        open={inactiveDialogOpen}
        onClose={() => handleInactiveDialogClose}
        onConfirm={() => handleMarkInactive(selectedRows, false)}
        message={dialogMessage}
      />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={openSnackbar}
        autoHideDuration={10000}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={severity}
          icon={getIcon()}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {showLoader && <Loader />}
    </div>
  );
};

export default Items;
